import { useQuery } from '@tanstack/react-query';
import { IAccountSnapshot } from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IAccountFilterCriteria } from '../../../viewmodels/AdminViewModels';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

export const ADMIN_ACCOUNT_SNAPSHOT_BY_MONTH_BASE_KEY = `admin/accountsnapshot/byMonth`;

const BASE_KEY = ADMIN_ACCOUNT_SNAPSHOT_BY_MONTH_BASE_KEY;

export function useAdminAccountSnapshotByMonthQuery({ filter }: { filter: IAccountFilterCriteria }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_KEY, filter],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IAccountSnapshot[]>(`admin/accountsnapshot/byMonth`, 'POST', filter),
	});
}

export const invalidateAdminAccountSnapshotByMonthQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_KEY] });
};
